function LabelIcon(props) {
  const { className, color, height, width } = props

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 14"
      className={className}
      width={ width ? width : "17" }
      height={ height ? height : "14" }
      fill={color ? color : "none"}>
        <path d="M0.475011 11.7L3.50001 7L0.475011 2.3C0.141677 1.8 0.125011 1.29167 0.425011 0.775C0.725011 0.258333 1.16668 0 1.75001 0H10.95C11.3167 0 11.65 0.0958332 11.95 0.2875C12.25 0.479167 12.5083 0.716667 12.725 1L16.375 6.125C16.5583 6.39167 16.65 6.68333 16.65 7C16.65 7.31667 16.5583 7.60833 16.375 7.875L12.725 13C12.5083 13.2833 12.25 13.5208 11.95 13.7125C11.65 13.9042 11.3167 14 10.95 14H1.75001C1.16668 14 0.725011 13.7417 0.425011 13.225C0.125011 12.7083 0.141677 12.2 0.475011 11.7ZM1.75001 12.5H11.25L15.15 7L11.25 1.5H1.75001L5.30001 7L1.75001 12.5Z"/>
    </svg>
  );
}

export { LabelIcon };
